import styled from 'styled-components'
import { breakpoints } from '../../../../../constants'

export const StyledForm = styled.form`
	padding-top: 2rem;

	.col1 {
		& > * {
			margin-bottom: 4rem;
		}
	}

	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		.col1 {
			display: grid;
			grid-gap: 15px;
			align-items: end;
			grid-template-columns: repeat(5, 1fr);
		}
	}
`

export const StyledPoints = styled.div`
	font-size: 2.8rem;
	margin: 15px 0;
	display: flex;

	.saldo {
		margin-right: 20px;
	}
`
